export default {
  apiKey: 'AIzaSyBzBJ-wO8-q0_Tw9vDN1OYEUB8y9G3xgaA',
  authDomain: 'femi-patient-app.firebaseapp.com',
  databaseURL: 'https://femi-patient-app.firebaseio.com',
  projectId: 'femi-patient-app',
  storageBucket: 'femi-patient-app.appspot.com',
  messagingSenderId: '959359787407',
  appId: '1:959359787407:web:fde7fd5b319d382980abfa',
  measurementId: 'G-K3RTXM1152',
};
